import { Type } from 'class-transformer';
import { IsNotEmptyObject, IsOptional, ValidateNested } from 'class-validator';

import { NotificationTypeDto } from './notification-type.dto';

export class NotificationSubscriptionsDto {
  @IsOptional()
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => NotificationTypeDto)
  orderShipment?: NotificationTypeDto;
}
